import { Component, OnInit, DoCheck } from "@angular/core";
import { ShowHistoricalSearchService } from "../../../core/history/show-historical-search.service";
import { Router } from "@angular/router";
import { AuthenticationService } from "@core/authentication/authentication.service";

@Component({
  selector: "bid-search-historical",
  templateUrl: "./search-historical.component.html",
  styleUrls: ["./search-historical.component.scss"],
})
export class SearchHistoricalComponent implements OnInit, DoCheck {
  currentPageHistoricalSearch: boolean;
  activeHistoricalSearch: boolean;
  showHistoricalSearch: boolean;

  constructor(
    public showHistoricalSearchService: ShowHistoricalSearchService,
    private router: Router,
    private authService: AuthenticationService
  ) {
    this.currentPageHistoricalSearch = false;
  }

  ngOnInit() {
    this.checkCurrentUrl(this.router.url);
  }

  ngDoCheck() {
    this.showHistoricalSearchService
      .getShowHistoricalSearch()
      .subscribe((res: any) => {
        this.showHistoricalSearch = res;
        this.checkCurrentUrl(this.router.url);
      });
  }

  checkCurrentUrl(currentUrl) {
    if (currentUrl === "/historical") {
      this.currentPageHistoricalSearch = true;
    } else {
      if (this.authService.msalService.getAccount()) {
        this.activeHistoricalSearch = this.showHistoricalSearch;
        this.currentPageHistoricalSearch = false;
      } else {
        this.activeHistoricalSearch = false;
      }
    }
  }

  showHistorical() {
    this.showHistoricalSearch = !this.showHistoricalSearch;
    this.activeHistoricalSearch = this.showHistoricalSearch;
    this.showHistoricalSearchService.setShowHistoricalSearch(
      this.showHistoricalSearch
    );
  }
}
